<div class="container main-container">
    <app-change-password [passwordResetMode]="true" [token]="token" [userName]="userName" [isReg]="isReg"></app-change-password>
</div>
